import ImportRecords from './import-records.js';


export default class ImportStudents extends ImportRecords {


	constructor(params = {})
	{
		const defaults = { 
			container:   '.import-students',
			contents:    '.student-list',
			cached_key:  'queued-students',
			spinner_msg: 'Importing students...please wait',
			ajax_path:   '/admin/import/students/partials'
		}

		var p = { ...defaults, ...params };

		super(p);
	}


}